module.exports = __webpack_public_path__ + "img/illu-step5-head.5dd4e328.svg";